// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"885e86fc","72":"073f73f7","477":"6c9c85d0","627":"f47008b2","663":"92bbe724","667":"17e22cfe","777":"c0eddf96","803":"35a2ce2e","820":"6d2a43a6"}[chunkId] + ".chunk.js";
};